import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/variables.css';
import './styles/global.css';
import App from './App';
import { logger } from './utils/logger';

// Global ChunkLoadError yakalama (özellikle production'da önbellek kaynaklı hataları çözmek için)
window.addEventListener('unhandledrejection', (event) => {
  const message = event?.reason?.message || '';
  if (/ChunkLoadError|Loading chunk/gi.test(message)) {
    // Tekrarlayan reload döngüsünü engellemek için localStorage bayrağı
    const key = 'last-chunk-error-reload';
    const last = localStorage.getItem(key);
    const now = Date.now();
    if (!last || now - parseInt(last, 10) > 15000) { // 15 sn içinde tekrar etmesin
      localStorage.setItem(key, now.toString());
      window.location.reload();
    }
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // React.StrictMode kaldırıldı: geliştirmede çift mount ve duplicate logları engellemek için
  <App />
);

// Service Worker kaydı (production'da)
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        logger.log('✅ Service Worker kayıtlı:', registration.scope);
        
        // Güncelleme kontrolü
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // Yeni versiyon mevcut, kullanıcıya bildir
                logger.log('🔄 Yeni versiyon mevcut. Sayfayı yenileyin.');
              }
            });
          }
        });
      })
      .catch((error) => {
        logger.error('❌ Service Worker kayıt hatası:', error);
      });
  });
}